import styled from "styled-components";

export const Container = styled.div`
  width: 70%;
  height: 350px;
  display: flex;
  // border-radius: 10px;
  // box-shadow: 0px 30px 60px 0px rgba(92, 99, 105, 0.15);
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2);
  @media screen and (max-width: 480px) {
    width: 96%;
    height: 200px;
  }
`;
export const Left = styled.div`
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 480px) {
    width: 60%;
  }
`;
export const Main = styled.div`
  width: 80%;
  height: 300px;
  @media screen and (max-width: 480px) {
    height: 200px;
  }
`;
export const Number = styled.p`
  font-size: 35px;
  margin-bottom: 10px;
  @media screen and (max-width: 480px) {
    font-size: 20px;
    margin-top: 3px;
  }
`;
export const Title = styled.p`
  font-size: 25px;
  margin-bottom: 10px;
  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;
export const Desc = styled.p`
  text-align: justify;
  text-justify: inter-word;

  @media screen and (max-width: 480px) {
    font-size: 10px;
  }
`;
export const Right = styled.div`
  width: 40%;
`;
export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
